import type { Translations } from '@/smarttext/translationsTypes.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { stripTranslationTags } from '@/app/components/translations/translationTags.ts';

export type TranslationDictionary = { [key: string]: string };

type CreateTranslationDictionaryProps = {
  lang: string;
  locale: string;
  translations: Translations;
};
export const createTranslationDictionary = ({
  lang,
  locale,
  translations,
}: CreateTranslationDictionaryProps): TranslationDictionary => ({
  ...(translations[lang.toLowerCase()] || {}),
  ...(translations[locale.toLowerCase()] || {}),
});

export const getTranslationServer = (key: string, translationDictionary: TranslationDictionary): string =>
  translationDictionary?.[key] || '';

/**
 * The `t` of `useTranslation` for server code: the same `__name__` placeholders, filled from the
 * dictionary, and the same highlight markup stripped, so a server-built string reads exactly as
 * the page would render it.
 */
export const createTranslationFunctionServer =
  (translationDictionary: TranslationDictionary): TranslationFunction =>
  (key, interpolationMap = {}) =>
    stripTranslationTags(
      Object.entries(interpolationMap).reduce(
        // A function keeps a value literal: as a string, "$$" or "$&" in a hotel name would be
        // read as a replacement pattern.
        (translation, [name, value]) => translation.replace(`__${name}__`, () => value),
        getTranslationServer(key, translationDictionary)
      )
    );
